"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterestShiftType = void 0;
exports.instanceOfInterestShiftType = instanceOfInterestShiftType;
exports.InterestShiftTypeFromJSON = InterestShiftTypeFromJSON;
exports.InterestShiftTypeFromJSONTyped = InterestShiftTypeFromJSONTyped;
exports.InterestShiftTypeToJSON = InterestShiftTypeToJSON;
exports.InterestShiftTypeToJSONTyped = InterestShiftTypeToJSONTyped;
/**
 *
 * @export
 */
exports.InterestShiftType = {
    Day: 'DAY',
    Evening: 'EVENING',
    Night: 'NIGHT',
    Weekend: 'WEEKEND',
    Rotating: 'ROTATING',
    Other: 'OTHER'
};
function instanceOfInterestShiftType(value) {
    for (const key in exports.InterestShiftType) {
        if (Object.prototype.hasOwnProperty.call(exports.InterestShiftType, key)) {
            if (exports.InterestShiftType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function InterestShiftTypeFromJSON(json) {
    return InterestShiftTypeFromJSONTyped(json, false);
}
function InterestShiftTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function InterestShiftTypeToJSON(value) {
    return value;
}
function InterestShiftTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=InterestShiftType.js.map